import { createContext } from 'react';
import HolidaysManagementContextPropsType from './HolidaysManagementContextPropTypes';
import config from './config';

export default createContext<HolidaysManagementContextPropsType>(config);
